import React, { useContext } from 'react';
import { ApplicationTrackerContext } from '../../contexts/ApplicationTrackerContext';
import { GlobalContext } from '../../contexts/GlobalContext';
import EmailAccessButton from '../LoginWithGoogle/EmailAccessButton';

const LoginWithGoogleBanner = React.forwardRef((props, ref) => {
  const { emailScrapingAllowed, setAutoScraperInfoModalOpen } =
    useContext(ApplicationTrackerContext);
  const { trialStatus } = useContext(GlobalContext);

  // Check if user has access to email scraping (not on basic trial)
  const canUseEmailScraping = trialStatus
    ? !trialStatus.has_trial || trialStatus.trial_type === 'full'
    : true;

  // Don't show banner if user is on basic trial
  if (!canUseEmailScraping) {
    return null;
  }

  return (
    <div className="bg-linear-to-r from-purple-600 to-blue-400">
      <div className="max-w-340 px-4 py-4 sm:px-6 lg:px-8 mx-auto">
        <div className="grid justify-center md:grid-cols-2 md:justify-between md:items-center gap-2">
          <div className="text-center md:text-start md:order-2 md:flex md:justify-end md:items-center">
            <p className="me-5 inline-block text-md font-semibold text-white">Try it out now!</p>
            <EmailAccessButton
              ref={ref}
              onBeforeRequest={() => setAutoScraperInfoModalOpen(true)}
            />
          </div>

          <div className="flex items-center">
            <a className="py-2 px-3 inline-flex justify-center items-center gap-2 rounded-lg font-medium text-white  transition text-md">
              Want InternHub to track your applications
              <strong>&#10024; automatically &#x2728; </strong>?
            </a>
          </div>
        </div>
      </div>
    </div>
  );
});

export default LoginWithGoogleBanner;
